export const getRightPageFromUrl = (): number | null => {
  const url = new URL(window.location.href)
  const rightPageString = url.searchParams.get('rpage')
  const rightPageFromUrl = rightPageString ? parseInt(rightPageString) : null

  return rightPageFromUrl
}
